/** Possible claim types. These should match the claim types allowed on the backend */
export enum ClaimTypesEnum {
    Disability = 'Disability',
    /** DEPRECATED. Synonymous with IU. This remains for backwards-compatibility with older records */
    Jobloss = 'Jobloss'
}
